module.exports = ".home-container {\n  width: 100%;\n  height: calc(100% - 70px - 52px); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main